import NotificationsSerializer from './base';

export default class Subscription extends NotificationsSerializer {}
